<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          :value="bike.manafacturer"
          :rules="[v => !!v || 'Manufacturer is required']"
          label="Brand / Make"
          hint="If you are unsure, please type NA"
          autofocus
          outlined
          required
          dense
          @input="$emit('bikeUpdate', { value: $event, key: 'manafacturer' })"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          :value="bike.colour"
          :rules="[v => !!v || 'Colour is required']"
          label="Colour"
          hint="The colour of the bicycle, will help us identify it in our workshop."
          outlined
          required
          dense
          @input="$emit('bikeUpdate', { value: $event, key: 'colour' })"
        />
      </v-col>
    </v-row>
    <a
      class="caption"
      @click="showOptionalData = !showOptionalData"
    >
      Click to provide more information about your bike (Optional)
      <v-icon v-if="!showOptionalData" color="primary" x-small>mdi-arrow-down-drop-circle</v-icon>
      <v-icon v-else color="primary" x-small>mdi-arrow-up-drop-circle</v-icon>
    </a>
    <v-row v-if="showOptionalData" class="mt-2">
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          :value="bike.model"
          :rules="[v => !!v || 'Model is required']"
          label="Model"
          hint="Can often be found on the top tube or seat tube in smaller writing"
          outlined
          required
          dense
          @input="$emit('bikeUpdate', { value: $event, key: 'model' })"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          :value="bike.type"
          :items="services[0].available_types"
          item-text="value"
          item-value="key"
          label="Type"
          hint="What type of bike do you have?"
          outlined
          required
          dense
          @change="$emit('bikeUpdate', { value: $event, key: 'type' })"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
      >
        <v-checkbox
          :input-value="bike.is_electric"
          @change="$emit('bikeUpdate', { value: $event, key: 'is_electric' }); trackServices()"
        >
          <template v-slot:label>
            My bike is electric <v-icon right color="primary">mdi-bicycle-electric</v-icon>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>

    <v-alert v-if="bike.is_electric" type="warning" text outlined class="mb-6">
      <strong>Important</strong> We are delighted to work on any road legal electric bicycle. We are unable to work on bicycles that are not road legal, for example those with throttles or modifications.
    </v-alert>

    <v-row>
      <v-col
        cols="12"
      >
        <v-textarea
          :value="bike.customer_notes"
          label="Any Specific Issues with Your Bike? (Optional)"
          outlined
          dense
          hint="Any additional notes that will help our mechanics, or tell us about any issues you want us to look at."
          persistent-hint
          @input="$emit('bikeUpdate', { value: $event, key: 'customer_notes' })"
        />
      </v-col>
    </v-row>

    <v-row class="mt-4">
      <v-col
        cols="12"
        sm="6"
      >
        <v-select
          :value="bike.service_sku"
          :items="availableServices"
          :item-text="service => `${service.name} - £${service.price}`"
          item-value="sku"
          label="Service"
          persistent-hint
          outlined
          required
          dense
          @change="$emit('bikeUpdate', { value: $event, key: 'service_sku' }); trackServiceClick($event)"
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <div class="service-image">
          <div class="most_popular">
            <img
              v-if="selectedService.popular"
              width="150px"
              src="https://d2w46cz0afxd34.cloudfront.net/assets/most-popular.png"
            >
          </div>
          <img
            :src="selectedService.main_img"
            class="service_img"
            height="150px"
            width="100%"
          >
          <div v-if="$store.getters.promoIsActive('BF2021') && ['deluxe', 'super_deluxe'].includes(selectedService.sku)" class="blackfriday-service-banner">
            £30 off with code BF2021
          </div>
          <div v-else-if="$store.getters.promoIsActive('FREECLEAN') && ['deluxe'].includes(selectedService.sku)" class="promo-banner">
            £30 off with code FREECLEAN
          </div>
        </div>
        <div class="pt-2">
          <p>{{ selectedService.description }}</p>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import filter from 'lodash.filter'
import find from 'lodash.find'
import orderBy from 'lodash.orderby'

export default {
  name: 'BikeForm',

  props: {
    showServiceSelector: {
      type: Boolean,
      required: false,
      default: () => { return false }
    },

    bike: {
      type: Object,
      required: true
    },

    services: {
      type: Array,
      required: true
    },

    position: {
      type: Number,
      required: true
    }
  },

  data () {
    return {
      showOptionalData: false
    }
  },

  watch: {
    'bike.is_electric': function (isElectric) {
      this.$emit('bikeUpdate', { value: isElectric ? this.bike.service_sku + '_electric' : this.bike.service_sku.replace('_electric', ''), key: 'service_sku' })
    }
  },

  mounted () {
    this.trackServices()
  },

  computed: {
    availableServices () {
      return orderBy(this.bike.is_electric ? this.electricServices : this.normalServices, 'order')
    },

    selectedService () {
      var selectedService
      this.availableServices.forEach(service => {
        if (service.sku === this.bike.service_sku) {
          selectedService = service
        }
      })
      return selectedService
    },

    normalServices () {
      return filter(this.services, { electric: false })
    },

    electricServices () {
      return filter(this.services, { electric: true })
    },

    notesRules () {
      if (this.bike.service_sku === 'fix_me_fit_me') {
        return [v => !!v || 'Notes are required for this service type']
      }
      return []
    }
  },

  methods: {
    trackServices () {
      var formattedServices = []
      this.availableServices.forEach((service, key) => {
        formattedServices.push({
          name: service.name,
          id: service.sku,
          price: service.price,
          brand: 'havebike',
          category: 'Service',
          list: this.bike.is_electric ? 'Electric' : 'Regular',
          position: (key + 1) + ((this.position - 1) * this.availableServices.length)
        })
      })
      window.dataLayer.push({
        ecommerce: {
          currencyCode: 'GBP',
          impressions: formattedServices
        }
      })
    },

    trackServiceClick (sku) {
      var service = find(this.services, { sku: sku })
      if (service) {
        window.dataLayer.push({
          event: 'productClick',
          ecommerce: {
            click: {
              actionField: { list: this.bike.is_electric ? 'Electric' : 'Regular' },
              products: [{
                name: service.name,
                id: service.sku,
                price: service.price,
                brand: 'havebike',
                category: 'Service',
                position: this.position
              }]
            }
          }
        })
      }
    }
  }
}
</script>
<style type="text/css" scoped>
  .service-image {
    position: relative;
  }
  .most_popular {
    position: absolute;
    top: 0;
    right: 0;
    width: 150px;
  }
  .promo-banner,
  .blackfriday-service-banner {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    font-weight: bold;
    padding: 4px 16px;
  }
  .promo-banner {
    background: var(--theme-primary);
    color: white;
  }
  .blackfriday-service-banner {
    background: #ffec3d;
    color: #000000;
  }
  .service_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .service_img {
    object-fit: cover;
  }
</style>
